/* global define */

window._define('widgets/threadPost', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';

    $.widget('OC.threadPost', BaseWidget, {
        options: {

        },

        _create: function () {
            this._super();
            this._attachEvents();

            // this should be done before all modification of the post content with JS
            this.content = this.element.find('.js-post-content').html().trim();
        },

        _attachEvents: function () {
            var self = this;

            this.element
                .on('click', '.js-action-quote', function (event) {
                    event.preventDefault();
                    self.quote();
                });
        },

        quote: function () {
            var data = $.extend(this.getData(), {action: 'quote'});
            this._trigger('action', null, data);
        },

        getData: function () {
            var $element = this.element,
                author = $element.find('.js-post-author > a').html().trim(),
                content = this.content;

            return {
                author: author,
                content: content
            };
        }
    });

    return $.OC.threadPost;

});
